import { render } from "./AssetBody.vue?vue&type=template&id=093a7571"
import script from "./AssetBody.vue?vue&type=script&lang=js"
export * from "./AssetBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__